import React, { useState } from "react";
import ReactDOM from 'react-dom';
import "./sidebar.css";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PersonIcon from '@mui/icons-material/Person';
import LaptopWindowsRoundedIcon from '@mui/icons-material/LaptopWindowsRounded';
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import AirlinesRoundedIcon from "@mui/icons-material/AirlinesRounded";
import ImportExportRoundedIcon from "@mui/icons-material/ImportExportRounded";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import SportsTennisOutlinedIcon from "@mui/icons-material/SportsTennisOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import DataArrayIcon from "@mui/icons-material/DataArray";
import DownloadingIcon from '@mui/icons-material/Downloading';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { useMainContent } from "../../../context/MainContentContext"; // Import the context
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import logo from '../../../assets/finkraft_logo.png'
import logout from '../../../assets/logout.png'
import dashboard from '../../../assets/dashboard.png'
import { auth } from '../../../firebase'; // Adjust the path to your firebase configuration
import { signOut } from 'firebase/auth';
import { useUnsavedChanges } from "../../../context/UnsavedChangesContext";



const Sidebar = (props) => {
  const [open, setOpen] = React.useState(true);
  


  const navigate = useNavigate();


  const [showPopup, setShowPopup] = useState(false);
  const { setMainContentData } = useMainContent();
const handleCancel = () => {
  setShowPopup(false);
};


  const {
    isDirty,
    setShowNavigationModal,
    setPendingNavigation,
  } = useUnsavedChanges();

  const handleNavigation = (path) => {
    if (isDirty) {
      // If there are unsaved changes, show the modal
      setShowNavigationModal(true);
      setPendingNavigation(() => () => navigate(path)); // Store the navigation action
    } else {
      // If no unsaved changes, navigate directly
      navigate(path);
    }
  };




// const handleLogout = async () => {
//   try {
//     await signOut(auth); // Sign out the user
//     setShowPopup(false); // Close any popups if necessary
//     navigate('/login'); // Redirect to the login page
//   } catch (error) {
//     console.error('Error signing out:', error);
//     // Handle errors here, such as displaying a notification to the user
//   }
// };

const handleLogout = async () => {
  try {
    await signOut(auth); // Sign out the user
    setMainContentData({
      gstin: "",
      gstinData: [],
      gstinDetails: {},
      filingData: {},
      Avgdelaydata: {},
      gstr1FilingDates: [],
      gstr3bFilingDates: [],
      hsnData: [],
      prevDtls: [],
      rgdt: "N/A",
      aggreTurnOver: "N/A",
      legalName: "N/A",
      tradeName: "N/A",
      einvoiceStatus: "N/A",
      statusColor: "#B0B0B0",
      gstinCount: "N/A",
    }); // Reset the main content data
    setShowPopup(false); // Close any popups if necessary
    navigate("/login"); // Redirect to the login page
  } catch (error) {
    console.error("Error signing out:", error);
  }
};


  return (
    <>
    <div className="Sidebar">
      <div className="topImage">
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',gap:'20px'}}>
        <img style={{ width: '40px', height: '40px' }} src={logo} />
        <div
        onClick={() => handleNavigation("/dashboard")}
        className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <div  style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
          <img src={dashboard}/>
          <span className="side-text">Dashboard</span>
        </div>
        </div>
        </div>

        <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',gap:'20px'}}>
        <div
        onClick={() => handleNavigation("/settings")}
        className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.0112 2.25C12.7452 2.258 13.4762 2.343 14.1932 2.503C14.3458 2.53705 14.4839 2.6179 14.5882 2.73426C14.6926 2.85062 14.7579 2.99667 14.7752 3.152L14.9452 4.679C14.9692 4.89428 15.0434 5.10093 15.1619 5.28231C15.2803 5.46368 15.4397 5.61473 15.6271 5.72329C15.8146 5.83185 16.0249 5.89489 16.2411 5.90735C16.4574 5.9198 16.6736 5.88132 16.8722 5.795L18.2722 5.18C18.4145 5.11735 18.5727 5.10044 18.725 5.13161C18.8772 5.16278 19.0161 5.24049 19.1222 5.354C20.1343 6.43516 20.8882 7.73163 21.3272 9.146C21.3731 9.29474 21.3716 9.45406 21.3228 9.60189C21.2741 9.74971 21.1806 9.87871 21.0552 9.971L19.8142 10.887C19.6394 11.0152 19.4972 11.1827 19.3992 11.3761C19.3012 11.5695 19.2501 11.7832 19.2501 12C19.2501 12.2168 19.3012 12.4305 19.3992 12.6239C19.4972 12.8173 19.6394 12.9848 19.8142 13.113L21.0572 14.028C21.1828 14.1204 21.2764 14.2495 21.3252 14.3976C21.3739 14.5456 21.3753 14.7051 21.3292 14.854C20.8905 16.2683 20.137 17.5647 19.1252 18.646C19.0192 18.7595 18.8807 18.8372 18.7286 18.8686C18.5765 18.8999 18.4185 18.8833 18.2762 18.821L16.8702 18.204C16.6718 18.117 16.4557 18.0779 16.2394 18.09C16.0231 18.102 15.8127 18.1648 15.6251 18.2733C15.4376 18.3817 15.2782 18.5328 15.16 18.7143C15.0417 18.8958 14.9678 19.1026 14.9442 19.318L14.7742 20.844C14.7573 20.9975 14.6933 21.142 14.5911 21.2578C14.4889 21.3736 14.3535 21.4551 14.2032 21.491C12.7549 21.8363 11.2456 21.8363 9.79724 21.491C9.64684 21.4553 9.51116 21.3739 9.40877 21.2581C9.30638 21.1423 9.24228 20.9976 9.22524 20.844L9.05624 19.32C9.03169 19.1053 8.95714 18.8994 8.83857 18.7187C8.72001 18.5381 8.56073 18.3877 8.37353 18.2798C8.18633 18.1718 7.97643 18.1093 7.76068 18.0972C7.54493 18.0851 7.32935 18.1237 7.13124 18.21L5.72524 18.826C5.58289 18.8885 5.42464 18.9053 5.27236 18.8739C5.12008 18.8426 4.98131 18.7647 4.87524 18.651C3.86336 17.5685 3.11014 16.2706 2.67224 14.855C2.62614 14.7061 2.62756 14.5466 2.6763 14.3986C2.72505 14.2505 2.8187 14.1214 2.94424 14.029L4.18724 13.113C4.36209 12.9848 4.50428 12.8173 4.60229 12.6239C4.7003 12.4305 4.75138 12.2168 4.75138 12C4.75138 11.7832 4.7003 11.5695 4.60229 11.3761C4.50428 11.1827 4.36209 11.0152 4.18724 10.887L2.94424 9.973C2.8187 9.88065 2.72505 9.75148 2.6763 9.60345C2.62756 9.45542 2.62614 9.29588 2.67224 9.147C3.11128 7.73263 3.86516 6.43616 4.87724 5.355C4.98342 5.24149 5.12225 5.16378 5.27452 5.13261C5.4268 5.10144 5.58499 5.11835 5.72724 5.181L7.12724 5.796C7.32626 5.88227 7.54274 5.92066 7.75929 5.90809C7.97583 5.89551 8.18642 5.83232 8.37411 5.7236C8.56181 5.61487 8.72139 5.46363 8.84003 5.28204C8.95867 5.10045 9.03306 4.89356 9.05724 4.678L9.22724 3.152C9.2444 2.99635 9.30984 2.84998 9.4144 2.73341C9.51895 2.61684 9.65737 2.53592 9.81024 2.502C10.5262 2.34333 11.2599 2.25933 12.0112 2.25ZM11.9992 9C11.2036 9 10.4405 9.31607 9.87792 9.87868C9.31531 10.4413 8.99924 11.2044 8.99924 12C8.99924 12.7956 9.31531 13.5587 9.87792 14.1213C10.4405 14.6839 11.2036 15 11.9992 15C12.7949 15 13.558 14.6839 14.1206 14.1213C14.6832 13.5587 14.9992 12.7956 14.9992 12C14.9992 11.2044 14.6832 10.4413 14.1206 9.87868C13.558 9.31607 12.7949 9 11.9992 9Z" fill="#C3C4CD"/>
</svg>
<span className="side-text">Settings</span> 
          </div>
          </div>
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}} onClick={() => setShowPopup(true)}>
            <img src={logout}/>

             <span className="side-text">LogOut</span> 
          </div>
        </div>
      </div>
    
    </div>
    {showPopup && ReactDOM.createPortal(
  <div
    style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1000,
      backgroundColor: '#fff',
      borderRadius: '16px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      padding: '30px 40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '420px',
    }}
  >
    {/* Alert Icon */}
    <div
    >
      <span style={{ fontSize: '50px' }}>⚠️</span>
    </div>

    <h2 style={{ marginBottom: '12px', color: '#333', fontWeight: '700' }}>
      Logout Confirmation
    </h2>

    <p style={{ marginBottom: '24px', color: '#555', fontSize: '15px' }}>
      Are you sure you want to log out?
    </p>

    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <button
        onClick={handleCancel}
        style={{
          backgroundColor: '#f0f0f0',
          color: '#333',
          border: '1px solid #ccc',
          padding: '10px 30px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: '500',
        }}
      >
        Cancel
      </button>
      <button
        onClick={handleLogout}
        style={{
          backgroundColor: '#e74c3c',
          color: '#fff',
          border: 'none',
          padding: '10px 30px',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: '500',
        }}
      >
        Logout
      </button>
    </div>
  </div>,
  document.body
)}

    </>
  );
};

export default Sidebar;
